<template>
  <div class="">
    <top-header :type="8" :hasBorder="true" :placeholder="'搜索'" :bgColor="'#fff'" fontSize="0.32rem"
                @comfirmText="comfirmText"/>
    <div id="line" class="pad_top"></div>
    <div class="cover_opc" @touchmove.prevent v-show="showCover"></div>
    <div class="tab_con m_flex_box flex_jz fixed">
      <div class="inner_con">
        <p class="text m_flex_box flex_vc flex_hc" :class="tab.showArea === true ? 'active' : ''"
           @click="setTab('showArea')">
          <span class="line_comp1">{{tabText.showArea ? tabText.showArea : '区域'}}</span>
          <van-icon name="play"/>
        </p>
        <transition name="slide-y" mode="out-in">
          <div class="inner_list inner_form" v-show="tab.showArea">
            <p :class="formData.xzqh === item.xzqh_code ? 'active' : ''"
               @click="setVal('xzqh', item.xzqh_code, item.xzqh_name, 'showArea')"
               v-for="(item, index) in xzqhArray" :key="index">{{item.xzqh_name}}</p>
          </div>
        </transition>
      </div>
      <div class="inner_con">
        <p class="text m_flex_box flex_vc flex_hc" :class="tab.showPrice === true ? 'active' : ''"
           @click="setTab('showPrice')">
          <span class="line_comp1">{{tabText.showPrice ? tabText.showPrice : '价格'}}</span>
          <van-icon name="play"/>
        </p>
        <transition name="slide-y" mode="out-in">
          <div class="price_list inner_form" v-show="tab.showPrice">
            <div class="m_flex_box price_inner">
              <div class="right flex-1">
                <p :class="formData.price === '' ? 'active' : ''" @click="setVal('price', '', '', 'showPrice')">不限</p>
                <div v-show="xzqhDefault==='320300'">
                  <p :class="formData.price === item.value ? 'active' : ''"
                     @click="setVal('price', item.value, item.text, 'showPrice')" v-for="(item, index) in utilPrice"
                     :key="index">{{item.text}}</p>
                </div>
                <div v-show="xzqhDefault!=='320300'">
                  <p :class="formData.price === item.value ? 'active' : ''"
                     @click="setVal('price', item.value, item.text, 'showPrice')" v-for="(item, index1) in utilPrice1"
                     :key="index1">{{item.text}}</p>
                </div>
              </div>
            </div>
            <div class="bottom_con m_flex_box flex_vc flex_jz">
              <div class="m_flex_box flex_vc">
                <span class="tit">自定义</span>
                <input type="number" v-model="min"><i>-</i><input type="number" v-model="max">
                <p>元</p>
              </div>
              <van-button type="info" @click="priceConfirm">确定</van-button>
            </div>
          </div>
        </transition>
      </div>
      <div class="inner_con">
        <p class="text m_flex_box flex_vc flex_hc" :class="tab.showSort === true ? 'active' : ''"
           @click="setTab('showSort')">
          <span class="line_comp1">{{tabText.showSort ? tabText.showSort : '排序'}}</span>
          <van-icon name="play"/>
        </p>
        <transition name="slide-y" mode="out-in">
          <div class="inner_list inner_form" v-show="tab.showSort">
            <p :class="!formData.sort ? 'active' : ''" @click="setVal('sort', '', '', 'showSort')">默认排序</p>
            <p :class="formData.sort === 0 ? 'active' : ''" @click="setVal('sort', 0, '最新开盘', 'showSort')">最新开盘</p>
            <p :class="formData.sort === 1 ? 'active' : ''" @click="setVal('sort', 1, '新房单价最低', 'showSort')">新房单价最低</p>
            <p :class="formData.sort === 2 ? 'active' : ''" @click="setVal('sort', 2, '新房单价最高', 'showSort')">新房单价最高</p>
            <p :class="formData.sort === 3 ? 'active' : ''" @click="setVal('sort', 3, '二手房单价最低', 'showSort')">二手房单价最低</p>
            <p :class="formData.sort === 4 ? 'active' : ''" @click="setVal('sort', 4, '二手房单价最高', 'showSort')">二手房单价最高</p>
            <p :class="formData.sort === 5 ? 'active' : ''" @click="setVal('sort', 5, '新房最多', 'showSort')">新房最多</p>
            <p :class="formData.sort === 6 ? 'active' : ''" @click="setVal('sort', 6, '二手房最多', 'showSort')">二手房最多</p>
          </div>
        </transition>
      </div>
    </div>
    <div class="list">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="no_data" v-if="!list.length">
            <img src="@/assets/img/nodata.png" alt="">
          </div>
          <div class="inner m_flex_box flex_vc" v-for="(item, index) in list" :key="index"
               @click="toDetail(item.id,item.old)">
            <img v-show="item.xmfm" v-lazy="imgPath + 'sImgMin/' + item.xmfm + '.jpg'" class="pic" alt="">
            <img v-show="!item.xmfm" src="@/assets/img/default_house_list.jpg" class="pic" alt="">
            <div class="right">
              <div class="top_con m_flex_box flex_vc flex_jz">
                <h5 class="line_comp1">{{item.tgmc ? item.tgmc : '-'}}</h5>
              </div>
              <div class="text_con m_flex_box flex_vc">
                <span>{{item.xzqhStr ? item.xzqhStr : '-'}}</span>
                <i>/</i>
                <span>{{item.jgsj ? item.jgsj+'建成' : '-'}}</span>
              </div>
              <p class="text_con">二手房{{item.oldTs ? item.oldTs : '0'}}套</p>
              <div class="price_con m_flex_box flex_vc">
                <h5><span>{{item.oldJg==0 ? '暂无' : item.oldJg+'元/平'}}</span></h5>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <slide-img></slide-img>
  </div>
</template>

<script>
import topHeader from '@/components/header'
import slideImg from '@/components/slideImg'
import qs from "qs"
export default {
  name: 'FindProject',
  data() {
    return {
      collect_y: require('@/assets/img/collect.png'),
      collect_n: require('@/assets/img/collect_.png'),
      utilPrice: [{
        value: '5000-10000',
        text: '10000元/m²以下'
      }, {
        value: '10001-15000',
        text: '10001-15000元/m²'
      }, {
        value: '15001-17000',
        text: '15001-17000元/m²'
      }, {
        value: '17001-20000',
        text: '17001-20000元/m²'
      }, {
        value: '20001-25000',
        text: '20001-25000元/m²'
      }, {
        value: '25001-30000',
        text: '25001-30000元/m²'
      }, {
        value: '30001-50000',
        text: '30001元/m²以上'
      }],
      utilPrice1: [{
        value: '1000-5000',
        text: '5000元/m²以下'
      }, {
        value: '5001-6000',
        text: '5001-6000元/m²'
      }, {
        value: '6001-7000',
        text: '6001-7000元/m²'
      }, {
        value: '7001-8000',
        text: '7001-8000元/m²'
      }, {
        value: '8001-9000',
        text: '8001-9000元/m²'
      }, {
        value: '9001-10000',
        text: '9001-10000元/m²'
      }, {
        value: '10001-20000',
        text: '10000元/m²以上'
      }],
      tab: {
        showArea: false,
        showPrice: false,
        showSort: false,
      },
      tabText: {
        showArea: '',
        showPrice: '',
        showSort: '',
      },
      formData: {
        xzqh: this.main.getHostArea(),
        price: '',
        max_price: '',
        min_price: '',
        xmmc: '',
        sort: '',
      },
      priceType: 1,
      min: '',
      max: '',
      showCover: false,
      isLoading: false,
      loading: false,
      finished: false,
      xzqhDefault: this.main.getHostArea(),
      xzqhArray: [],
      items: '',
      list: [],
      listPage: 1,
    };
  },
  components: {
    topHeader,
    slideImg
  },
  mounted() {
    this.getArea();
    this.getMonth();
  },
  methods: {
    toDetail(itemId, old) {
      var path = '/projectDetail';
      if (old == 1) {
        path = '/projectDetailIndex';
      }
      this.$router.push({
        path: path,
        query: {itemId}
      })
    },
    getMonth() {
      this.month = new Date().getMonth() + 1;
    },
    comfirmText(data) {
      this.loading = false;
      this.finished = false;
      this.$set(this, 'list', []);
      this.$set(this, 'listPage', 1);
      this.$set(this.formData, 'xmmc', data);
      this.onLoad();
    },
    getArea() {
      this.$new.post('xzqh/getXzqh.do').then(res => {
        if (res.obj) {
          if (this.xzqhDefault === '320300') {
            this.xzqhArray = res.obj[0].xzqhs;
            this.items = {xzqh_code: '320300', xzqh_name: '主城区'};
            this.xzqhArray.splice(0, 0, this.items);
          } else {
            res.obj.forEach((item) => {
              if (this.xzqhDefault === item.xzqh_code) {
                this.$set(this, 'xzqhArray', [item])
              }
            });
          }
        }
      })
    },
    onRefresh() {
      this.loading = false;
      this.finished = false;
      this.$set(this, 'list', []);
      this.$set(this, 'listPage', 1);
      this.onLoad(1);
    },
    onLoad(type) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50)
        this.$http({
          url: 'cms/itemSearch/permit/getPageByOffsetByInfoNew.do',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            xzqh: this.formData.xzqh,
            pageSize: 10,
            offset: (this.listPage - 1) * 10,
            sort: this.formData.sort,
            max_price: this.formData.max_price,
            min_price: this.formData.min_price,
            xmmc: this.formData.xmmc
          }
        }).then(res => {
          if (type) {
            this.isLoading = false;
          }
          if (res.success) {
            this.list = this.list.concat(res.obj.rows)
            this.loading = false;
            this.listPage += 1;
          } else {
            this.finished = true;
          }
        })
      }
    },
    setTab(type) {
      this.showPad = true;
      for (let key in this.tab) {
        if (type === key) {
          this.$set(this.tab, type, !this.tab[type]);
        } else {
          this.$set(this.tab, key, false)
        }
        if (this.tab[type]) {
          this.showCover = true
        } else {
          this.showCover = false
        }
      }
    },
    setVal(type, v, t, tab) {
      this.$set(this.formData, type, v);
      if (type === 'price') {
        this.$set(this.formData, 'min_price', v.split('-')[0])
        this.$set(this.formData, 'max_price', v.split('-')[1])
        console.log(this.formData)
      }
      if (tab) {
        this.$set(this.tab, tab, false);
        this.$set(this.tabText, tab, t);
        this.showCover = false;
      }
      this.loading = false;
      this.finished = false;
      this.$set(this, 'list', []);
      this.$set(this, 'listPage', 1);
      this.onLoad();
    },
    // 价格判断
    priceConfirm() {
      if (this.min && this.max) {
        if (this.min > this.max) {
          this.$set(this.formData, 'min_price', this.max);
          this.$set(this.formData, 'max_price', this.min);
          this.min = this.formData.min_price;
          this.max = this.formData.max_price;
        } else {
          this.$set(this.formData, 'max_price', this.max);
          this.$set(this.formData, 'min_price', this.min);
          this.min = this.formData.min_price;
          this.max = this.formData.max_price;
        }
        this.$set(this.tabText, 'showPrice', this.min + '-' + this.max + '万元');
        this.$set(this, 'listPage', 1);
        this.loading = false;
        this.finished = false;
        this.list = [];
        this.onLoad();
      }
      this.$set(this.tab, 'showPrice', false);
      this.showCover = false;
    },
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'ProjectDetail' || to.name === 'ProjectDetailIndex'){
      this.$store.dispatch('saveView', ['FindProject']).then(() => {
        next()
      })
    } else {
      this.$store.dispatch('saveView', []).then(() => {
        next()
      })
    }
  },
};
</script>
<style lang="less" scoped>
.tab_con{
    padding: 0 0.16rem;
    font-size: 0.28rem;
    position: relative;
    border-bottom: 1px solid #E9E9E9;
    z-index: 2;
    background-color: #fff;
    &.fixed{
      position: fixed;
      top: 1.1rem;
      left: 0;
      right: 0;
      border-top: 1px solid #E9E9E9;
    }
    .inner_con{
      .text{
        padding: 0.2rem 0rem;
        text-align: center;
        width: 1.2rem;
        .van-icon{
          transition: all 0.3s;
          color: #CECECE;
          transform: rotate(90deg);
          margin-left: 0.06rem;
          font-size: 0.2rem;
        }
        &.active{
          color: #2F72F5;
          .van-icon{
            transform: rotate(-90deg);
            color: #2F72F5;
          }
        }
      }
      .inner_form{
        background-color: #fff;
        position: absolute;
        left: 0;
        right: 0;
        top: calc(100% + 0.02rem);
        max-height: 7.12rem;
        overflow: auto;
      }
      .inner_list{
        padding: 0 0.5rem;
        p{
          line-height: 0.99rem;
          box-sizing: border-box;
          border-bottom: 1px solid #F4F4F4;
          text-align: center;
          &:last-child{
            border: none;
          }
          &.active{
            color: #2F72F5;
          }
        }
      }
      .price_list{
        .price_inner{
          height: 5.92rem;
        }
        .left{
          border-right: 1px solid #f4f4f4;
          width: 45%;
        }
        .right{
          box-sizing: border-box;
          padding-left: 0.2rem;
          max-height: 5.92rem;
          overflow: auto;
        }
        p{
          line-height: 0.99rem;
          box-sizing: border-box;
          border-bottom: 1px solid #F4F4F4;
          text-align: center;
          &:last-child{
            border: none;
          }
          &.active{
            color: #2F72F5;
          }
        }
      }
      .bottom_con{
        height: 1.2rem;
        box-sizing: border-box;
        border-top: 1px solid #f4f4f4;
        padding: 0 0.3rem;
        input{
          width: 1.38rem;
          height: 0.78rem;
          border: 1px solid #f4f4f4;
          text-align: center;
        }
        .tit{
          margin-right: 0.2rem;
        }
        i{
          margin: 0.1rem;
        }
        p{
          margin-left: 0.2rem;
        }
        .van-button{
          height: 0.78rem;
        }
      }
    }
  }
  .pad_top{
    padding-top: 0.82rem;
  }
  .list{
    width: 7.04rem;
    margin: 0 auto;
    .inner{
      border-bottom: 1px solid #f5f5f5;
      padding: 0.35rem 0;
      .pic{
        width: 2.28rem;
        height: 1.72rem;
        margin-right: 0.3rem;
      }
      .right{
        width: 4.4rem;
        .top_con{
          margin-bottom: 0.08rem;
          h5{
            width: 80%;
            font-weight: 800;
            font-size: 0.32rem;
          }
          img{
            width: 0.28rem;
          }
        }
        .text_con{
          margin-bottom: 0.08rem;
          font-size: 0.24rem;
          color: #505050;
          .col_ori{
            color: #FF5932;
            margin-right: 0.14rem;
          }
          i{
            margin: 0 0.14rem;
          }
        }
        .price_con{
          h5{
            color: #FF5932;
            font-size: 0.24rem;
            span{
              font-size: 0.28rem;
              font-weight: 800;
            }
          }
          p{
            margin-left: 0.12rem;
            font-size: 0.24rem;
            color: #9a9a9a;
          }
        }
      }
    }
  }
</style>